import React, { useState } from "react";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PPIService from "../../services/PPIService";
import Modal from "react-modal";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

Modal.setAppElement("#root"); // Set this once at app root level

const MinKycOtpVerify = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const { verificationToken, message } = location.state || {};

  const [otp, setOTP] = useState("");

  const verifyOtpHandler = async () => {
    if (!otp.trim()) return Swal.fire("Oops!", "Please enter OTP", "error");

    setLoading(true);
    try {
      const result = await PPIService.minKycVerifyOtp(otp, verificationToken);

      if (!result.success) {
        return Swal.fire(
          "Oops!",
          result.message || "Failed to generate OTP",
          "error"
        );
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        // Redirect with token and message
        navigate("/min-kyc/verify-document", {
          state: {
            verificationToken,
          },
        });

        //  Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Header />

      <div className="bg-light py-3 px-3  d-flex align-items-center justify-content-center">
        <div className="card rounded-4 w-100" style={{ maxWidth: "1200px" }}>
          <div className="card-body p-4">
            <h4 className="mb-4 text-center">
              PPI User Onboarding | Verify OTP
            </h4>

            {message && (
              <div className="alert alert-success" role="alert">
                {message}
              </div>
            )}

            <div className="mb-3">
              <label className="form-label">OTP</label>
              <input
                type="text"
                className="form-control"
                value={otp}
                onChange={(e) => setOTP(e.target.value)}
                placeholder="OTP (One Time Password)"
              />
            </div>

            <button
              className="btn btn-primary w-100"
              onClick={verifyOtpHandler}
              disabled={loading}
            >
              {loading ? "Processing..." : "Verify OTP"}
            </button>

            <div className="pt-3"></div>
            {/* Powered By */}
            <hr />
            <div className="text-center">
              <small className="text-muted d-block mb-1">ISSUED BY</small>
              <img
                src="/images/pine-labs-logo.png"
                alt="Pine Labs"
                style={{ height: "22px" }}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default MinKycOtpVerify;
